<script setup lang="ts" generic="T extends SelectOption">
import { computed } from 'vue';

import type { SelectOption } from '@/classes/SelectOption';
import ChoiceChip from '@/components/forms/controls/ChoiceChip.vue';

const props = defineProps<{
  options: T[]
  showInputs?: boolean;
}>();

const modelValue = defineModel<string[]>('modelValue', {
  default: () => []
});

const value = computed({
  get() {
    return modelValue.value ?? [];
  },
  set(newValues: string[]) {
    modelValue.value = newValues;
  }
});

function handleToggle(checked: boolean, optionValue: string) {
  const currentValues = [...value.value];
  
  if (checked) {
    if (!currentValues.includes(optionValue)) {
      currentValues.push(optionValue);
    }
  } else {
    const index = currentValues.indexOf(optionValue);
    if (index > -1) {
      currentValues.splice(index, 1);
    }
  }
  
  value.value = currentValues;
}
</script>

<template>
  <menu class="toggleGroup">
    <li v-for="(option, index) in props.options"
        :key="index"
        class="toggleGroup-item">
      <ChoiceChip type="checkbox"
                  :option="option"
                  :checked="value.includes(option.value)"
                  :show-input="props.showInputs"
                  @change="handleToggle" />
    </li>
  </menu>
</template>

<style lang="scss">
.toggleGroup {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--buttonGap, 8px);

  &-item {
    // styles pour les éléments de liste si nécessaire
  }
}
</style>
